import { render, staticRenderFns } from "./Crowd.vue?vue&type=template&id=7f38d32e"
import script from "./Crowd.vue?vue&type=script&lang=js"
export * from "./Crowd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports